import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Seo } from "../components/Seo";
import { CallCta } from "../components/CallCta";
import { Testimonials } from "../components/Testimonials";
import { BUSINESS } from "../data/site";

const IMG = "https://images.unsplash.com/photo-1591658522986-9eb791d2a89a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxXaW5uaXBlZyUyME1hbml0b2JhJTIwY2l0eXNjYXBlJTIwc2t5bGluZSUyMGFlcmlhbHxlbnwwfHx8fDE3OTIzNzQyNzZ8MA&ixlib=rb-4.1.0&q=85";

export default function Indigenous() {
  return (
    <div data-testid="indigenous-page">
      <Seo
        title="Indigenous-Owned Security Company Manitoba | First Nations"
        description="1st Nations Security is an Indigenous-owned security guard company serving First Nations communities and all sectors across Manitoba. 24/7 dispatch."
        path="/indigenous-security/"
      />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMG} alt="Manitoba landscape — traditional territory served by 1st Nations Security" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-[#0D0E11]/70" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6 max-w-3xl">
            An <span className="text-[#FF9100]">Indigenous-Owned</span> Security Company Serving Manitoba
          </h1>
          <p className="text-lg text-gray-300 leading-relaxed max-w-3xl mb-4">
            1st Nations Security is proudly Indigenous-owned and operated. Our sun logo stands for what we bring to every post: warmth, vigilance, and a commitment to the communities we come from. We deliver professional security guard services to First Nations, commercial, industrial, municipal, and residential clients across Manitoba.
          </p>
          <p className="text-gray-400 leading-relaxed max-w-3xl">
            Choosing an Indigenous-owned security company means your security spending stays in the community — creating employment, building skills, and supporting economic sovereignty while you get disciplined, licensed, professionally managed protection.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-6">Security for First Nations Communities</h2>
            <p className="text-gray-400 leading-relaxed mb-6">
              We build security programs under the direction of Chief and Council, community leadership, and Indigenous organizations — for band offices, schools, health facilities, community events, and public spaces. Our teams engage with cultural safety and respect, and we hire from within the community wherever possible.
            </p>
            <ul className="space-y-4">
              {[
                "Community-first programs designed with local leadership",
                "Local hiring with support toward Manitoba security guard licensing",
                "Culturally safe, trauma-informed engagement standards",
                "Event security for powwows, gatherings, and celebrations",
                "Facility security for band offices, schools, and health centres",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-300" data-testid={`indigenous-point-${i}`}>
                  <Check className="w-5 h-5 text-[#FF9100] mt-0.5 shrink-0" /> {item}
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <Link to="/security-services/indigenous-community-security" data-testid="indigenous-service-link" className="inline-flex items-center gap-2 text-[#FF9100] font-semibold hover:gap-3 transition-all">
                Learn about Indigenous Community Security →
              </Link>
            </div>
          </div>
          <div>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-6">For Commercial & Public Sector Clients</h2>
            <p className="text-gray-400 leading-relaxed mb-6">
              Working with 1st Nations Security helps organizations meet Indigenous procurement and partnership goals without compromising on professionalism. We hold our guards to the same licensing, training, supervision, and reporting standards as any leading security company in Manitoba — and we answer our phones 24/7.
            </p>
            <div className="bg-[#14161C] border border-[#FF9100]/25 rounded-2xl p-6" data-testid="indigenous-badge-card">
              <p className="text-xs font-semibold uppercase tracking-widest text-[#FF9100] mb-2">Our Commitment</p>
              <p className="text-gray-300 leading-relaxed">
                100% Indigenous-Owned & Community Dedicated Security Provider — serving Winnipeg, Brandon, Thompson, and every region of Manitoba with pride.
              </p>
            </div>
            <div className="mt-6 bg-[#14161C] border border-white/10 rounded-2xl p-6">
              <p className="text-sm text-gray-400 leading-relaxed">
                Reach our team any time at <a href={BUSINESS.phoneHref} className="text-[#FF9100] hover:underline" data-testid="indigenous-phone-link">{BUSINESS.phone}</a> or <a href={BUSINESS.emailHref} className="text-[#FF9100] hover:underline" data-testid="indigenous-email-link">{BUSINESS.email}</a>.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Testimonials />
      <CallCta heading="Partner With an Indigenous-Owned Security Company" sub="Call our 24/7 line to discuss security for your community, site, or organization." testid="indigenous-cta" />
    </div>
  );
}
